import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {TaxSearchModel} from "../tax-search.model";
import {TaxSearchPageComponent} from "../tax-search-page/tax-search-page.component";
import {TaxEditPageComponent} from "../tax-edit-page/tax-edit-page.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";

@Component({
    selector: "wbo-tax-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(TaxMultiSelectEditControlComponent),
        provideSearchModel(TaxSearchModel)
    ]
})
export class TaxMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<TaxSearchModel> {
    constructor(model: TaxSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = TaxSearchPageComponent;
        this.extendedEditComponent = TaxEditPageComponent;
    }
}
